import { point, polygon, booleanPointInPolygon } from "@turf/turf";
var L = window.L;
// var cci=0;
var relatedpointer = {
  indexfn(pinterarr, len) {
    console.time("查询时间");
    //经度 lng x轴  →递增
    //纬度 lat y轴  ↓递减
    var This = this;
    var centerRelatedPinter =
      this.getPathLevel(pinterarr) === 3 ? pinterarr[0][0] : pinterarr[0]; //中心点 默认第一个点
    var twopointer = this.getBoundPinterfn(pinterarr);
    var lngfirst = twopointer[0][1],
      latfirst = twopointer[0][0];
    var xval = twopointer[1][1] - twopointer[0][1],
      yval = twopointer[0][0] - twopointer[1][0];
    var ylen = ((len * yval) / xval).toFixed(5);
    var marixArr = this.printMatrix(this.newMarixFn(len, ylen));
    var lngval = xval / (len - 1),
      latval = yval / (ylen - 1);
    marixArr = marixArr.reverse();
    function incenterfn(length) {
      var pointer = [];
      for (var i = 0; i < marixArr.length; i++) {
        var xyOffset = marixArr[i].split("-");
        var offsetPointerLng = lngfirst + parseInt(xyOffset[0]) * lngval;
        var offsetPointerLat = latfirst - parseInt(xyOffset[1]) * latval;
        var result = This.morePoinersInMapfn(
          [offsetPointerLat, offsetPointerLng],
          pinterarr,
          length
        );
        if (result) {
          pointer.push(offsetPointerLat);
          pointer.push(offsetPointerLng);
          break;
        }
      }
      if (pointer.length > 0) {
        return pointer;
      } else {
        if (length < 0.000005) {
          return false;
        } else {
          return incenterfn(length / 2);
        }
      }
    }
    var related = incenterfn((xval / (len - 1)) * 4);
    if (related) {
      //有值
      centerRelatedPinter.length = 0;
      centerRelatedPinter = related;
    }
    //console.log(cci)
    console.timeEnd("查询时间");
    return centerRelatedPinter;
  },
  morePoinersInMapfn(center, pointers, len) {
    //经度 lng x轴  →递增
    //纬度 lat y轴  ↓递减
    //lng,lat
    /*[-1,1]  [0,1]  [1,1]
		[-1,0]  [0,0]  [1,0]
		[-1,-1] [0,-1] [1,-1]*/
    var results = [];
    var arr = [
      [0, 0],
      [1, 0],
      [1, -1],
      [0, -1],
      [-1, -1],
      [-1, 0],
      [-1, 1],
      [0, 1],
      [1, 1],
    ];
    for (var i = 0; i < arr.length; i++) {
      var result = this.pointerIsInMapfn(
        [center[0] + arr[i][1] * len, center[1] + arr[i][0] * len],
        pointers
      );
      //cci++;
      results.push(result);
    }
    return results.every((item) => item);
  },
  printMatrix(matrix) {
    //矩阵获取顺时针 点集合
    // write code here
    if (matrix == null || matrix[0].length == 0) {
      return;
    }
    var hang = matrix.length;
    var lie = matrix[0].length;
    var start = 0;
    var res = [];
    while (lie > start * 2 && hang > start * 2) {
      var endx = lie - 1 - start;
      var endy = hang - 1 - start;
      //左到右一行
      for (var i = start; i <= endx; i++) {
        res.push(matrix[start][i]);
      }
      //上到下一行
      if (start < endy) {
        for (var j = start + 1; j <= endy; j++) {
          res.push(matrix[j][endx]);
        }
      }
      //右到左
      if (start < endx && start < endy) {
        for (var k = endx - 1; k >= start; k--) {
          res.push(matrix[endy][k]);
        }
      }
      //下到上
      if (start < endx && start < endy - 1) {
        for (var n = endy - 1; n >= start + 1; n--) {
          res.push(matrix[n][start]);
        }
      }
      start++;
    }
    return res;
  },
  newMarixFn(xlen, ylen) {
    //新建一个 指定大小的数矩阵
    /*
		0-0 0-1 0-2 0-3 0-4
		1-0 1-1 1-2 1-3 1-4
		2-0 2-1 2-2 2-3 2-4
		3-0 3-1 3-2 3-3 3-4
		4-0 4-1 4-2 4-3 4-4
		*/
    if (xlen < 0 || ylen < 0) {
      return [];
    }
    var marixarr = [];
    for (var x = 0; x < xlen; x++) {
      var xitem = [];
      for (var y = 0; y < ylen; y++) {
        var xyitem = "";
        xyitem = x + "-" + y;
        xitem.push(xyitem);
      }
      marixarr.push(xitem);
    }
    return marixarr;
  },
  getBoundPinterfn(pinterarr) {
    //获取对角线坐标
    var polygon = L.polygon(pinterarr, {}).getBounds();
    return [
      [polygon.getNorthWest().lat, polygon.getNorthWest().lng],
      [polygon.getSouthEast().lat, polygon.getSouthEast().lng],
    ];
  },
  pointerIsInMapfn(pointer, path) {
    if (pointer && path) {
      const poly = polygon(this.getPathLevel(path) === 3 ? path : [path]);
      let result = booleanPointInPolygon(point(pointer), poly);
      if (result) {
        return true;
      } else {
        return false;
      }
    }
  },
  getPathLevel(path) {
    if (
      isHave(path) &&
      isHave(path[0]) &&
      isHave(path[0][0]) &&
      isHave(path[0][0][0])
    ) {
      return 4;
    }
    if (isHave(path) && isHave(path[0]) && isHave(path[0][0])) {
      return 3;
    }
    if (isHave(path) && isHave(path[0])) {
      return 2;
    }
    if (isHave(path)) {
      return 1;
    }
    return 0;
    function isHave(item) {
      return item && Array.isArray(item) && item.length;
    }
  },
};
export default relatedpointer;
